import { useContext } from "react";
import { UserContext } from "../context-providers/user.provider";

const useSubject = () => {
  // Return the current subject and allows current subject to be set
  // Note the assignment screen is for all subject. Only once an assingment has been opened can a subject be defined
  const { subject, setSubject } = useContext(UserContext);

  return { subject, setSubject };
};

export default useSubject;
